import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { observable, Observable, of } from 'rxjs';
import { AuthorizationService } from './authorization.service';
import { MasterService } from './master-mom.service';
import { RSAHelper } from '../services/RSAHelper';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public headers: Headers;
  apiURL: string = "";
  UserList: any = [];

  constructor(private _router: Router,public RSAHelper:RSAHelper, public authorizationService: AuthorizationService,public masterservice:MasterService) {
    //this.headers = new Headers({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: this.headers });
    //this.apiURL = baseUrl;

  }

  getCurrentLanguage() {

    // var lng = this._langService.getLang();
    // if (lng) { return lng.ISOCode; }
    //else { return 'en'; }
    return 'en';
  }

  

  logout() {
    this.authorizationService.signOut();
    sessionStorage.removeItem('iammwtoken');
    //let objusers = new Users;
    //var users = this.getUserInfo();
    //localStorage.removeItem('authorization.service.user_info');    
   
    //sessionStorage.removeItem('userinfo');
    //this.masterservice.logoutfromoneid();    
    //this._router.navigate(['/login']);
  }

  getUserInfo()
  {
    var user;
    //var struser = sessionStorage.getItem('userinfo');
    var struser = localStorage.getItem('authorization.service.user_info');    
    if (struser) {
      user = JSON.parse(struser);
    }
    //else this._router.navigate(['/login']);
    return user;
  }

  getUserProfileInfo(emailv:string):Observable<object>
  {
  
    var struser = sessionStorage.getItem('userinfo');    
    if(struser)
    {
      struser=JSON.parse(sessionStorage.getItem('userinfo'));
      return of(JSON.parse(sessionStorage.getItem('userinfo')));
    }
    if (!struser)
    {
      const objTxnData = {               
        "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(emailv))
    }
 
    return (this.masterservice.getprofileinfo(JSON.stringify(objTxnData)));
    
      //this.loaduserprofile(emailv);
      //struser=JSON.parse(sessionStorage.getItem('userinfo'));      
    /*      var usersectionInfoList:any;
          const objtrxndata = {               
              "email": emailv//this.useremail//"25305"
          }
          this.masterservice.getprofileinfo(objtrxndata)
          .subscribe((result: any) => {
              const response = result.data;
              if (response.length>0) {
                  usersectionInfoList=result.data;
          var employeeuno = (usersectionInfoList[0].employeeuno != null && usersectionInfoList[0].employeeuno !== '') ? usersectionInfoList[0].employeeuno : '';            
          var firstname=(usersectionInfoList[0].first_name!=null&&usersectionInfoList[0].first_name!="")?usersectionInfoList[0].first_name:'';
          var lastname = (usersectionInfoList[0].last_name!=null&&usersectionInfoList[0].last_name!="")?usersectionInfoList[0].last_name:'';
          var email = (usersectionInfoList[0].emailId!=null&&usersectionInfoList[0].emailId!="")?usersectionInfoList[0].emailId:'';
          var userPRnumber = (usersectionInfoList[0].corporate_id!=null&&usersectionInfoList[0].corporate_id!="")?usersectionInfoList[0].corporate_id:'';
          var division = (usersectionInfoList[0].division!=null&&usersectionInfoList[0].division!="")?usersectionInfoList[0].division:'';
          var designation = (usersectionInfoList[0].jobtitle!=null&&usersectionInfoList[0].jobtitle!="")?usersectionInfoList[0].jobtitle:'';
          var firsttimeiamaccess=(usersectionInfoList[0].firsttimeaccesstoiam!=null&&usersectionInfoList[0].firsttimeaccesstoiam!="")?usersectionInfoList[0].firsttimeaccesstoiam:'';          
          var struser = '{"employeeuno": "' + employeeuno + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","division":"' + division + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '","firsttimeaccesstoiam":"'+firsttimeiamaccess+'"}';
          sessionStorage.removeItem('userinfo');
          sessionStorage.setItem('userinfo', struser);
          return of(struser);
      }
    });*/
    }
    //return of(struser);   
  }

  getUserRights(pagename: string) {
    let userRightsData: any = [];  
    var struserRights = sessionStorage.getItem('userrights');
    if (struserRights) {
      var userRights: any = JSON.parse(struserRights);
      userRightsData = userRights.filter(item => item.pageName == pagename);
    }
    return userRightsData;
  }

  UpdatetUserTermsInfo() {
    var struser = sessionStorage.getItem('userinfo');
    if (struser) {
      struser = struser.replace('"termsandconditions":"0"', '"termsandconditions":"1"');
      sessionStorage.removeItem('userinfo');
      sessionStorage.setItem('userinfo', struser);
    }
  }

  /*  const objtrxndata = {               
      "email": emailv//this.useremail//"25305"
  return this.masterservice.getprofileinfo(objtrxndata)  
  }*/

loadprofiledata(usersectionInfoList)
{
  //var usersectionInfoList:any;
  var employeeuno = (usersectionInfoList[0].employeeuno != null && usersectionInfoList[0].employeeuno !== '') ? usersectionInfoList[0].employeeuno : '';            
  var firstname=(usersectionInfoList[0].first_name!=null&&usersectionInfoList[0].first_name!="")?usersectionInfoList[0].first_name:'';
  var lastname = (usersectionInfoList[0].last_name!=null&&usersectionInfoList[0].last_name!="")?usersectionInfoList[0].last_name:'';
  var email = (usersectionInfoList[0].emailId!=null&&usersectionInfoList[0].emailId!="")?usersectionInfoList[0].emailId:'';
  var userPRnumber = (usersectionInfoList[0].corporate_id!=null&&usersectionInfoList[0].corporate_id!="")?usersectionInfoList[0].corporate_id:'';
  var division = (usersectionInfoList[0].division!=null&&usersectionInfoList[0].division!="")?usersectionInfoList[0].division:'';
  var designation = (usersectionInfoList[0].jobtitle!=null&&usersectionInfoList[0].jobtitle!="")?usersectionInfoList[0].jobtitle:'';
  var firsttimeiamaccess=(usersectionInfoList[0].firsttimeaccesstoiam!=null&&usersectionInfoList[0].firsttimeaccesstoiam!="")?usersectionInfoList[0].firsttimeaccesstoiam:'';          
  var struser = '{"employeeuno": "' + employeeuno + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","division":"' + division + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '","firsttimeaccesstoiam":"'+firsttimeiamaccess+'"}';
  sessionStorage.removeItem('userinfo');
  sessionStorage.setItem('userinfo', struser);
  return struser;
}

  /*--------for userprofileinfo----------------------------*/
  loaduserprofile(emailv:string)
  {    
      try
      {
          debugger;
          var usersectionInfoList:any;
          const objTxnData = {               
              "email": this.RSAHelper.encryptWithPublicKey(JSON.stringify(emailv)) 
          }
        
          this.masterservice.getprofileinfo(JSON.stringify(objTxnData))
          .subscribe((result: any) => {
              const response = result.data;
              if (response.length>0) {
                  usersectionInfoList=result.data;
          var employeeuno = (usersectionInfoList[0].employeeuno != null && usersectionInfoList[0].employeeuno !== '') ? usersectionInfoList[0].employeeuno : '';            
          var firstname=(usersectionInfoList[0].first_name!=null&&usersectionInfoList[0].first_name!="")?usersectionInfoList[0].first_name:'';
          var lastname = (usersectionInfoList[0].last_name!=null&&usersectionInfoList[0].last_name!="")?usersectionInfoList[0].last_name:'';
          var email = (usersectionInfoList[0].emailId!=null&&usersectionInfoList[0].emailId!="")?usersectionInfoList[0].emailId:'';
          var userPRnumber = (usersectionInfoList[0].corporate_id!=null&&usersectionInfoList[0].corporate_id!="")?usersectionInfoList[0].corporate_id:'';
          var division = (usersectionInfoList[0].division!=null&&usersectionInfoList[0].division!="")?usersectionInfoList[0].division:'';
          var designation = (usersectionInfoList[0].jobtitle!=null&&usersectionInfoList[0].jobtitle!="")?usersectionInfoList[0].jobtitle:'';
          var firsttimeiamaccess=(usersectionInfoList[0].firsttimeaccesstoiam!=null&&usersectionInfoList[0].firsttimeaccesstoiam!="")?usersectionInfoList[0].firsttimeaccesstoiam:'';
          
          var struser = '{"employeeuno": "' + employeeuno + '","firstname":"' + firstname + '","lastname":"' + lastname + '","email":"' + email + '","division":"' + division + '","designation":"' + designation + '","userPRnumber":"' + userPRnumber + '","firsttimeaccesstoiam":"'+firsttimeiamaccess+'"}';
          sessionStorage.removeItem('userinfo');
          sessionStorage.setItem('userinfo', struser);
          //this.userprofileInfo = JSON.parse(sessionStorage.getItem('userinfo'));
      }
  });
      }
      catch(e){console.log(e);}
      //return of(struser);
  }

}
